import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/fp/isEmpty';

type FooterStepOneProps = {
    partnerName: string | undefined;
    handleClose: () => void;
    handleCreatePartner: () => void;
};

const FooterStepOne = ({ handleClose, handleCreatePartner, partnerName }: FooterStepOneProps) => (
    <ButtonToolbar alignment='right'>
        <Button onClick={handleClose}>
            <FormattedMessage id='intl-msg:network.label.cancel' />
        </Button>
        <Button
            bsStyle='primary'
            onClick={handleCreatePartner}
            disabled={isEmpty(partnerName)}
            iconName='chevron-right'
            iconRight
        >
            <FormattedMessage id='intl-msg:network.label.addPartner' />
        </Button>
    </ButtonToolbar>
);

export default FooterStepOne;
